/**
 * Centralized status labels for all entities
 * Single source of truth for status translations
 */
export const STATUS_LABELS: Record<string, string> = {
  // User status
  ACTIVE: "Attivo",
  INACTIVE: "Inattivo",
  TRIAL_SETUP: "Setup in corso",

  // Quote status
  DRAFT: "Bozza",
  SENT: "Inviato",
  ACCEPTED: "Accettato",
  REJECTED: "Rifiutato",

  // Contract status
  SIGNED: "Firmato",
  SUSPENDED: "Sospeso",
  // DRAFT and REJECTED shared with Quote

  // Payment status
  PLANNED: "Pianificato",
  TO_APPROVE: "Da Approvare",
  TO_INVOICE: "Da Fatturare",
  INVOICED: "Fatturato",
  PAID: "Pagato",
  OVERDUE: "Scaduto",
  CANCELLED: "Annullato",

  // Subtask status
  BACKLOG: "Backlog",
  TODO: "Da fare",
  IN_PROGRESS: "In corso",
  PENDING_VALIDATION: "Da validare",
  PENDING_APPROVAL: "Da timbrare",
  COMPLETED: "Completato",

  // Project status
  PROSPECT: "Prospetto",
  FINISHING: "In Chiusura",
  DECLINED: "Rifiutato",
  // IN_PROGRESS, COMPLETED shared with Subtask

  // Analytics status
  DELETED: "Eliminato",
};
